// Update main-layout.component.ts
import { CommonModule } from '@angular/common';
import {
  Component,
  HostListener,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { Subscription } from 'rxjs';
import { HeaderComponent } from '../../shared/header/header.component';
import { SidebarComponent } from '../../shared/sidebar/sidebar.component';
import { StudentPostLoginFlowService } from '../../shared/services/student-post-login-flow.service';
import { LandscapeAlertComponent } from '../../shared/components/alert/landscape-alert.component';
import { OrientationService } from '../../shared/services/orientation.service';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
  standalone: true,
  imports: [
    SidebarComponent,
    HeaderComponent,
    RouterOutlet,
    CommonModule,
    LandscapeAlertComponent, 
  ],
})
export class MainLayoutComponent implements OnInit, OnDestroy {
  @ViewChild(RouterOutlet) outlet!: RouterOutlet;

  isSidebarOpen: boolean = window.innerWidth > 1024;
  isMobile: boolean = window.innerWidth <= 1024;
  currentSearchValue: string = '';
  showLandscapeWarning: boolean = false;

  private routerSub?: Subscription;

  constructor(
    private router: Router,
    private studentPostLoginFlowService: StudentPostLoginFlowService,
    private orientationService: OrientationService, // Inject service
  ) {}

  ngOnInit(): void {
    // Listen to orientation changes
    this.orientationService.orientation$.subscribe((info) => {
      this.showLandscapeWarning = info.isMobile && info.isLandscape;
    });

    this.routerSub = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currentSearchValue = '';
        this.studentPostLoginFlowService.runIfNeeded();
        if (this.isMobile) {
          this.isSidebarOpen = false;
        }
      }
    });
    this.onResize();
    this.studentPostLoginFlowService.runIfNeeded();
  }

  ngOnDestroy(): void {
    this.routerSub?.unsubscribe();
  }

  toggleSidebar(): void {
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  closeSidebar(): void {
    this.isSidebarOpen = false;
  }

  onSearch(value: string): void {
    this.currentSearchValue = value;
    const component = this.outlet?.component as any;
    if (component) {
      if (typeof component.updateSearch === 'function') {
        component.updateSearch(value);
      } else if (
        'search' in component &&
        typeof component.applyFilter === 'function'
      ) {
        component.search = value;
        component.applyFilter();
      }
    }
  }

  @HostListener('window:resize')
  onResize(): void {
    this.isMobile = window.innerWidth <= 1024;
    this.isSidebarOpen = !this.isMobile;
  }
}
